import React, {useState, useEffect} from "react"
import {Modal, ModalHeader, ModalBody} from "reactstrap"

const Contact = ({isOpen, toggle, lang}) => {
  
  return <>
    <Modal isOpen={isOpen} toggle={toggle}  className="contact">
      <ModalHeader toggle={toggle}>{lang.contact.title}</ModalHeader>
      <ModalBody>
        <div className="row mb-5 contact">
          <div className="col-md-12 text">{lang.contact.description}</div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                  <ul>
                      <i className="fas fa-globe-asia icon"></i><br/><br/>
                      <li className="bold">{lang.footer.worldWideAssistance} </li>
                      <li>+603 7628 3860 / +603 7841 5770</li>
					  <li className="bold mt-3">{lang.footer.breakDownForPrivateCar} </li>
                      <li>1800 18 8033</li>
                 	  <li className="bold mt-3">{lang.footer.breakDownForMotorcycle}  </li>
                      <li>1300 88 2323</li>                                        
                  </ul>
              </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                  <ul>
                      <i className="fas fa-headphones-alt icon"></i><br/><br/>
                      <li className="bold">{lang.footer.cs}</li>
                      <li>{lang.footer.time}</li>
                      <li>{lang.footer.tel1}</li>
                      <li>{lang.footer.tel2}</li><br/>
                      <li><a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a></li>
                  </ul>
              </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 mt-5">
              <div className="border">
                  <ul>
                      <i className="fas fa-map-marker-alt icon"></i><br/><br/>
                      <li className="bold">Berjaya Sompo Insurance Berhad<br/>
                        {lang.contact.registrationNo}: 198001008821 (62605-U)</li>
                      <li>Level 36, Menara Bangkok Bank,
                          105, Jalan Ampang,
                          50450 Kuala Lumpur</li>
                  </ul>
              </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  </>
}

export default Contact